__turbopack_context__.v({
  "avatarContainer": "ogonIa_avatarContainer",
  "ctaButton": "ogonIa_ctaButton",
  "customizedBtn": "ogonIa_customizedBtn",
  "leftContentPadding": "ogonIa_leftContentPadding",
  "removeLeftIcon": "ogonIa_removeLeftIcon",
});
